<template>
  <span v-if="isKlassKnown">{{ label }}</span>
  <span v-else style="font-family:monospace">{{ label }}</span>
</template>

<script>

export default {
  computed: {
    label: function() {
      return this.getLabel(this.klass) || this.klass;
    },
    isKlassKnown: function() {
      return !!this.getLabel(this.klass);
    }
  },
  methods: {
    getLabel: function(klass) {
      if(klass == 'test') {
        return 'Test process';
      }
      else {
        return null;
      }
    }
  },
  props: {
    klass: [String]
  }
};
</script>
